import type { ReactNode } from 'react';
import { PanelCard } from './primitives';
import { SplitWorkspaceLayout } from './split-workspace';

export function EditorPageLayout({
  hero,
  heroAside,
  tabs,
  children
}: {
  hero: ReactNode;
  heroAside?: ReactNode;
  tabs?: ReactNode;
  children: ReactNode;
}): JSX.Element {
  return (
    <div className="av-page av-editor-page">
      <div className="av-editor-page__hero-grid">
        <div>{hero}</div>
        {heroAside ? <div>{heroAside}</div> : null}
      </div>
      {tabs ? <div className="av-editor-page__tabs">{tabs}</div> : null}
      {children}
    </div>
  );
}

export function EditorBodyLayout({ main, rail }: { main: ReactNode; rail?: ReactNode }): JSX.Element {
  return <SplitWorkspaceLayout main={main} rail={rail} />;
}

export function EditorHeroCard({
  actions,
  children,
  className
}: {
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <PanelCard actions={actions} className={['av-editor-hero-card', className ?? ''].filter(Boolean).join(' ')}>
      {children}
    </PanelCard>
  );
}

export function EditorSectionCard({
  title,
  actions,
  children,
  className
}: {
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <PanelCard title={title} actions={actions} className={['av-editor-section-card', className ?? ''].filter(Boolean).join(' ')}>
      {children}
    </PanelCard>
  );
}
